import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*',
'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable()
export class UserService {
    userUrl = '/superadmin/rest/mgmt/user';
    userCountUrl = '/superadmin/rest/mgmt/user/count?';
    getsaUserTypeUrl = '/superadmin/rest/mgmt/user/saUserType';
  constructor(private http: HttpClient) { }

  createUser(formData) {
    return this.http.post(this.userUrl , formData, { headers: headers });
  }
  getUsers(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.userUrl + '?' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });

  }
  getTotalFilterCount(filter) {
    return this.http.get(this.userCountUrl + filter, {headers});
  }
  getUserById(id ) {
    return this.http.get(this.userUrl + '/' + id ,  {headers: headers} );
  }
  changeUserStatus(status , id) {
    return this.http.put(this.userUrl + '/' + status + '/' +  id , {headers: headers});
  }
  updateUser(data, id) {
    return this.http.put(this.userUrl + '/' + id, data, {headers: headers});
  }
  getUserTypes() {
    return this.http.get(this.getsaUserTypeUrl, { headers: headers });
  }
}

